var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"d-flex justify-center align-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }